import { GET_TRACKING_APP_URL } from "../../utils/api-url";
import { getCall } from "../../utils/network.util";

export const fetchTrackingApp = (onSuccess = () => {}, onFailure = () => {}) => {
    getCall(GET_TRACKING_APP_URL)
        .then((response) => {
            if (response.status === "SUCCESS" && response.payload.Status === "SUCCESS") {
                onSuccess(response.payload.Payload.trackingApp);
            } else {
                onFailure();
            }
        })
        .catch((err) => {
            console.log({ err });
            onFailure();
        });
}
